"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgStatusUnknown = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none" }, props),
    React.createElement("path", { fill: "#8B93A6", fillRule: "evenodd", d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m-.805-6.394v.072h1.16v-.072q.012-.661.235-1.016t.738-.657q.543-.309.856-.756.316-.45.316-1.096 0-.623-.312-1.088a2.06 2.06 0 0 0-.872-.73Q8.76 4 8.014 4q-.681 0-1.245.244a2.13 2.13 0 0 0-.9.722q-.34.474-.369 1.161h1.233q.036-.607.426-.886t.855-.279q.518 0 .884.302.365.298.365.806 0 .428-.251.733a2.3 2.3 0 0 1-.609.52 3.4 3.4 0 0 0-.648.477q-.269.255-.414.675-.142.42-.146 1.13m.04 2.172q.24.222.572.222a.8.8 0 0 0 .572-.222q.24-.225.24-.542a.7.7 0 0 0-.24-.534.8.8 0 0 0-.572-.226.8.8 0 0 0-.571.226.7.7 0 0 0-.24.534q0 .317.24.542", clipRule: "evenodd" })));
exports.default = SvgStatusUnknown;
